import { ThemeProps } from 'styled-components';
import { Theme } from '../theme';

export type Spacing = ({ theme }: ThemeProps<Theme>) => string;

/**
 * Specifies spacing as a multiple of the base spacing value for the theme.
 *
 * @param multiplier how many multiples of the base spacing (8px for MT) to use.
 */
const spacing = (multiplier: number): Spacing => ({ theme }): string =>
  `${theme.layout.baseSpacingPx * multiplier}px`;

export const spacingWithBorder = (multiplier: number, borderPx: number): Spacing => ({
  theme,
}): string => `${theme.layout.baseSpacingPx * multiplier - borderPx}px`;

export default spacing;
